import { SAVEDATA } from '../actions/pages/saveDataAction';
import { CLEARDATA } from '../actions/pages/clearDataAction';

const storageKey = 'pagesData';

const dataReducer = (
  state = {
    data: JSON.parse(localStorage.getItem(storageKey)) || {},
  },
  action
) => {
  switch (action.type) {
    case SAVEDATA:
      localStorage.setItem(storageKey, JSON.stringify(action.data));
      return { ...state};
    case CLEARDATA:
      localStorage.removeItem(storageKey);
      return { ...state, data:{}};
    default:
      return state;
  }
};

export default dataReducer;
